import React from "react";
import PropTypes from "prop-types";
import { useIntl } from "react-intl";

import * as Utils from "../../../Utils/AnalyticsUtils";

import Card from "./TotalCumulCard";

import { faCogs, faComments, faCamera, faCloud, faFolderOpen } from "@fortawesome/free-solid-svg-icons";

const TotalCumulLine = (props) => {
    const intl = useIntl();

    return (
        <div className="row">
            <Card icon={faCogs} value={props.totalCumulData?.totalCumulAdministration ?? 0} title="ADMIN API" subTitle={intl.messages.apiCalled} />
            <Card icon={faComments} value={props.totalCumulData?.totalCumulResources ?? 0} title="RESOURCES API" subTitle={intl.messages.apiCalled} />
            <Card icon={faCamera} value={Utils.secondsToMin(props.totalCumulData?.totalCumulTraffic ?? 0)} title="TRAFFIC MN" subTitle={intl.messages.apiConsumed} />
            {props.showTurn && <Card icon={faCloud} value={props.totalCumulData?.totalCumulTurn ?? 0} title="TURN Bytes" subTitle={intl.messages.apiConsumed} />}
            <Card icon={faFolderOpen} value={props.totalCumulData?.totalCumulStorage ?? 0} title="STORAGE" subTitle={intl.messages.apiUsed} />
        </div>
    )
};

TotalCumulLine.defaultProps = {
    totalCumulData: {},
    showTurn: false
}

TotalCumulLine.propTypes = {
    totalData: PropTypes.object,
    showTurn: PropTypes.bool
};

export default TotalCumulLine;